import React from 'react';
import { Provider } from 'react-redux';
import store from '../../redux/store';
import AddToCartButtonContent from './AddToCartButtonContent';

const AddToCartButton = (props) => (
  <Provider store={store}>
    <AddToCartButtonContent {...props} />
  </Provider>
);

export default AddToCartButton;
